import axios from './index'

import prefix_ms from './prefix'



// 获取学习打卡分享内容
export const getDailyShareContent = (params) => {
    return axios.request({
        url: prefix_ms + `/shareReadRecord/share/content`,
        method: 'get',
        params: params,
    })
}

// 上报文章学习分享结果
export const postDailyReportShareResult = ({ shareRecordId }) => {
    return axios.request({
        url: prefix_ms + `/shareReadRecord/share/result/${shareRecordId}`,
        method: 'post',

    })
}

// 上报学习记录分享链接打开次数
export const reportRecordVisitInfo = ({ shareRecordId }) => {
    return axios.request({
        url: prefix_ms + `/shareRecordVisitInfo/report/${shareRecordId}`,
        method: 'post',

    })
}

//好友助力海报
export const getFindWeChatHelpQrcode = (params) => {
  return axios.request({
    url: prefix_ms + `/weixin/findWeChatHelpQrcode`,
    method: 'get',
    params: params,
  })
}

//获取日历分享信息
export const getCalendarShareInfo = (data) => {
    return axios.request({
      url: prefix_ms + `/shareReadRecord/calendar/share/getInfo`,
      method: 'post',
      data: data,
    })
  }

// /user/childInfo/{childUserId}
// 获取孩子信息
export const getUserChildUserId = (childUserId) => {
    return axios.request({
      url: prefix_ms + `/user/childInfo/${childUserId}`,
      method: 'get',
    })
  }
  
  // /shareChildReadRecord/findShareInfo/{shareId}
  // 获取分享信息
  export const getUserfindShareInfo = (shareId) => {
    return axios.request({
      url: prefix_ms + `/shareChildReadRecord/findShareInfo/${shareId}`,
      method: 'get',
    })
  }
  
  // /shareChildReadRecord/save/{childUserId}/{articleId}
  // 保存分享记录
  export const postShareChildReadRecord = (childUserId, articleId) => {
    return axios.request({
      url: prefix_ms + `/shareChildReadRecord/save/${childUserId}/${articleId}`,
      method: 'post',
    })
  }
  
  export const getChildRecordShareInfo = ({ childId, articleId, shareSource }) => {
    return axios.request({
      url: prefix_ms + `/shareChildReadRecord/getShareInfo`,
      method: 'post',
      data: { childId, articleId, shareSource },
    })
  }
  



//////////////////
// WEBPACK FOOTER
// ./app/api/share.js
// module id = null
// module chunks = 